import { styled } from '@topwrite/common';
import { ReactNode, useState } from 'react';
import { MdUnfoldLess, MdUnfoldMore } from 'react-icons/md';

interface Props {
    title: ReactNode;
    children: ReactNode;
    collapsed?: boolean;
    onCollapsedChange?: (collapsed: boolean) => void;
}

export default function Collapse({ title, children, collapsed: externalCollapsed, onCollapsedChange }: Props) {
    const [internalCollapsed, setInternalCollapsed] = useState(true);

    const collapsed = externalCollapsed !== undefined ? externalCollapsed : internalCollapsed;

    const handleToggle = () => {
        const newCollapsed = !collapsed;
        if (onCollapsedChange) {
            onCollapsedChange(newCollapsed);
        } else {
            setInternalCollapsed(newCollapsed);
        }
    };

    return <Container>
        <Header onClick={handleToggle}>
            <HeaderLeft>
                <CollapseButton>
                    {collapsed ? <MdUnfoldLess /> : <MdUnfoldMore />}
                </CollapseButton>
                <span>{title}</span>
            </HeaderLeft>
        </Header>
        {!collapsed && <Content>{children}</Content>}
    </Container>;
}


const Container = styled.div`
    background: var(--ttw-box-background);
    color: var(--ttw-box-color);
    border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color);
    border-radius: var(--bs-border-radius-lg);
    margin-bottom: .5rem;
    overflow: hidden;
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.25rem 0.25rem;
    user-select: none;
    background: var(--ttw-foreground);
    cursor: pointer;

    &:hover {
        background: var(--ttw-box-hover-background);
    }
`;

const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.857rem;
    font-weight: 500;
    color: var(--ttw-box-color);
`;

const CollapseButton = styled.button`
    background: none;
    border: none;
    color: var(--bs-secondary);
    padding: 0.375rem;
    border-radius: var(--bs-border-radius);
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 0.875rem;
        height: 0.875rem;
    }
`;


const Content = styled.div`
    background: var(--ttw-box-background);
    border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color);
`;
